// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import './assets/override.styl'
import VueScrollactive from 'vue-scrollactive'

import App from './App'
import router from './router'
import tools from './assets/tools.js'

import axios from '../node_modules/axios/dist/axios.js'

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'

import infiniteScroll from 'vue-infinite-scroll'

// Require Froala Editor js file.
require('froala-editor/js/froala_editor.pkgd.min')

// Require Froala Editor css files.
require('font-awesome/css/font-awesome.css')

import 'froala-editor/css/froala_style.min.css'
import 'froala-editor/css/froala_editor.pkgd.min.css'
import 'froala-editor/js/plugins.pkgd.min'

axios.interceptors.response.use((responseItem) => { // intercept the global error
  return responseItem
}, function (errorItem) {
  if (errorItem && errorItem.response && errorItem.response.status === 401) {
    console.error('Authorization failed, clearing local auth data.', errorItem)

    tools.signOut({
      skipAPIlogout: true,
      success: () => {
        router.push({
          name: 'MagicSignIn'
        })
      }
    })
  } else {
    return Promise.reject(errorItem)
  }
})

Vue.use(Vuetify, { theme: {
  primary: '#00bf1b',
  secondary: '#8D9AA3',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#00bf1b',
  warning: '#FFC107'
}})

Vue.use(require('vue-moment'))

Vue.use(VueScrollactive)
Vue.config.productionTip = false

Vue.use(VueFroala)

Vue.use(infiniteScroll)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

setTimeout(function () {
  location.reload()
}, 1000 * 60 * 60 * 8)



// WEBPACK FOOTER //
// ./src/main.js